<template>
  <app-modal class="add-new-field">
    <app-modal-default @close="close">
      <template v-slot:header>
        {{$ml.get(`New field`)}}
      </template>
      <template v-slot:content>
        <form @submit="createNewField($event)" class="form">

          <!-- {{$ml.get(`Field size`)}} : <b>{{inputs.fieldArea}} ha</b> -->

          <app-text-input
            :label="$ml.get(`Field size`)"
            type="number"
            v-model="inputs.fieldArea"
            :hint="'ha'"
            :min="0"
            :required="true"
          />

          <app-text-input
            :label="$ml.get(`Field name`)"
            :type="'text'"
            v-model="inputs.fieldName"
            :required="true"
          />

          <farm-selector v-model="inputs.farmId" @userDefinedFarmName="userDefinedFarmName" />
          <span class="tip">{{$ml.get(`Just type farm name if you want to add new farm`)}}</span>
          <app-sel
            v-model="fieldType"
            :label="$ml.get(`Field type`)"
            :filterable="true"
            :items="inputs.selectFieldType.values"
          >
            <template v-slot="{ items }">
              <app-sel-opt v-for="field in items" :value="field" :key="field.key" >
                {{field.label}}
              </app-sel-opt>
            </template>
          </app-sel>


          <app-textarea
            :label="$ml.get(`Description`)"
            :type="'text'"
            v-model="inputs.descr"
            rows="8"
          />
          <div class="buttons">
            <app-btn styling="outline" @click="close">{{$ml.get(`cancel`)}}</app-btn>
            <app-btn type="submit" :loading="isLoading">{{$ml.get(`save`)}}</app-btn>
          </div>
        </form>
      </template>
    </app-modal-default>
  </app-modal>
</template>

<script>
import API from '@/api'
import * as turf from '@turf/turf'

export default {
  props : {
    fieldGeometry : {
      required : true
    },
    fieldGeoType : {
      required : true
    },
    fieldLayer : {
      required : true
    },
  },
  data() {
    return {
      fieldType : {
        label : '',
        value : null,
      },
      isLoading: false,
      inputs : {
        fieldName: null,
        farmName: null,
        farmId : null,
        selectFieldType : {
          label : 'Field type',
          type : 'text',
          values : [
            {
              label: this.$ml.get(`Soil-grown`),
              key: 0,
              value: 'soil-grown',
            },
            {
              label: this.$ml.get(`Greenhouse`),
              key: 1,
              value: 'greenhouse',
            },
            {
              label: this.$ml.get(`Soil less culture`),
              key: 2,
              value: 'soil-less',
            }
          ],
          value : null,
          required : true
        },
        fieldArea: null,
        descr: null,
      },
      fieldData : {
        fieldName : null,
        farmName : null,
        farmId : null,
        fieldArea : null,
        descr : null,
        geometry : {
          type : this.fieldGeoType, //radial or polygon
          latlngs : null,
          center: null,
          radius: null,
          color : 'cornflowerblue'
        }
      }
    }
  },
  methods : {
    userDefinedFarmName(value) {
      this.fieldData.farmName = value;
    },
    createNewField(e) {
      e.preventDefault();
      this.isLoading = true;
      if (!this.inputs.fieldName) {
        this.isLoading = false;
        this.$notify({
          group: 'notices',
          title: this.$ml.get(`Field name required`),
          type : 'error',
        });
        return;
      }
      if (!this.fieldData.farmName && !this.inputs.farmId) {
        this.isLoading = false;

        this.$notify({
          group: 'notices',
          title: this.$ml.get(`Farm name required`),
          type : 'error',
        });

        return;
      }

      this.fieldData.fieldName = this.inputs.fieldName;
      this.fieldData.farmId = this.inputs.farmId;
      this.fieldData.fieldArea = this.inputs.fieldArea;
      this.fieldData.descr = this.inputs.descr;
      this.fieldData.fieldType = this.fieldType.value;

      if(this.fieldGeoType == 'polygon') {
        this.fieldData.geometry.latlngs = this.fieldGeometry[0][0];
      }else if (this.fieldGeoType == 'circle') {
        this.fieldData.geometry.center = this.fieldGeometry.center;
        this.fieldData.geometry.radius = this.fieldGeometry.radius;
      }else if (this.fieldGeoType == 'marker') {
        this.fieldData.geometry.latlngs = this.fieldGeometry;
        // this.fieldData.geometry.lng = this.fieldGeometry.lng;
      }
//=================================================================================
      return API.fields.createPolygon(this.fieldData)
        .then(res => {
          if(res.data.success) {
            this.$notify({
              group: 'notices',
              title: this.$ml.get(`Field was successfully created!`),
              type : 'success',
            });
            this.close();
            this.$store.dispatch('farms/updateData');
          }
          else{
            try {
              let result = JSON.parse(JSON.stringify(res));
              console.log(result.data.message);
              if (result.data.message == 'Please buy a plan!') {
                this.$notify({
                  group: "notices",
                  title: this.$ml.get(
                    `Please buy a plan before creating fields.`
                  ),
                  type: "error",
                });
              }
            } catch (e) {}
          }
        })
        .catch(err => {

        })
//=================================================================================
    },
    getFieldArea() {
      // получаем площадь поля в гектарах
      let _area = null;

      if(this.fieldGeoType === 'polygon') {
        _area = turf.area(this.fieldLayer.toGeoJSON() ) * 0.0001;
        console.log(this.fieldLayer);
      }else if(this.fieldGeoType === 'circle') {
        _area = this.fieldLayer._mRadius * this.fieldLayer._mRadius * Math.PI * 0.0001;
      }

      _area = parseFloat(_area.toFixed(2));
      return _area;
    },

    close() {
      this.$emit('close');
    }
  },
  mounted() {
    this.inputs.fieldArea = this.getFieldArea();
  }
}
</script>

<style lang="scss" scoped>

.add-new-field {

  .form {
    min-width: 350px;
    > * {
      margin-top: 24px;
    }
    .tip {
      display: block;
      margin-top: 5px;
      font-size: 14px;
      color: #bbb;
    }
    .buttons {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    @media(max-width:768px) {
      min-width: auto;
    }
  }
}

</style>
